export default __webpack_public_path__ + "media/images/indent-right-black-1e31c722042483a0ef0f29ec8f931c20.png";